import { useSelector } from '../../../_shared/utils/hooks/useSelector';
import { type AppState } from '../../app.store';

export const mapBaseMapStylesSelector = (state: AppState) => state.map.mapSettings.data.mapStyles;
export const useMapBaseMapStylesSelector = () => useSelector(mapBaseMapStylesSelector);
